module.exports = __webpack_public_path__ + "static/media/pdf.9632bfb5.svg";